import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { isPage } from '@bloomreach/spa-sdk';
import { useIntl, useFeatureToggles } from '@grandvisionhq/state';
import '@bloomreach/react-sdk';
import { useBrConfigurationContext } from '../context/configuration.js';
import '@grandvisionhq/search';
import { getContentByRef } from '../utils/get-content-by-ref.js';
import { getBrPageContent } from '../utils/get-br-page-content.js';
import '@grandvisionhq/utils';
import '@grandvisionhq/common';
import '../utils/http-client.js';
import { fetchPagedComponent } from './helpers/helpers.js';

function parseBloomreachArticles(pageable, highlighted, page) {
    const { currentPage , nextPage , totalPages , items =[]  } = pageable !== null && pageable !== void 0 ? pageable : {};
    let articles = [];
    let highlightedContent = undefined;
    if (isPage(page)) {
        highlightedContent = getBrPageContent(page, highlighted);
        articles = items.map((item)=>getBrPageContent(page, item)
        ).filter(Boolean);
    } else {
        var ref1;
        highlightedContent = (ref1 = getContentByRef(highlighted.$ref, page)) === null || ref1 === void 0 ? void 0 : ref1.data;
        articles = items.map((item)=>{
            var ref;
            return item && ((ref = getContentByRef(item.$ref, page)) === null || ref === void 0 ? void 0 : ref.data);
        }).filter(Boolean);
    }
    return {
        highlighted: highlightedContent,
        paged: {
            items: articles,
            currentPage,
            nextPage,
            totalPages
        }
    };
}
const useBloomreachArticles = ({ component , page  })=>{
    const { apiUrl  } = useBrConfigurationContext();
    const { locale  } = useIntl();
    const { isMultilingualEnabled  } = useFeatureToggles();
    const componentId = component.getId();
    const localeTransformed = locale.replace('-', '_');
    const url = isMultilingualEnabled ? `${apiUrl}/${localeTransformed}` : apiUrl;
    const { pageable: pageable1 , highlightedArticle: highlightedArticle1  } = component.getModels();
    const [loading, setLoading] = React.useState(false);
    const [error, setError] = React.useState();
    const [result1, setResult] = React.useState(()=>{
        return parseBloomreachArticles(pageable1, highlightedArticle1, page);
    });
    var _currentPage;
    const [currentPage, setCurrentPage] = React.useState((_currentPage = result1.paged.currentPage) !== null && _currentPage !== void 0 ? _currentPage : 1);
    const loadNextPage = React.useCallback(()=>{
        result1.paged.nextPage && setCurrentPage(result1.paged.nextPage);
    }, [
        result1.paged.nextPage
    ]);
    React.useEffect(()=>{
        if (currentPage === result1.paged.currentPage) {
            return;
        }
        const path = isMultilingualEnabled ? window === null || window === void 0 ? void 0 : window.location.pathname.replace(`/${localeTransformed}`, '') : window === null || window === void 0 ? void 0 : window.location.pathname;
        let current = true;
        setLoading(true);
        fetchPagedComponent(url, componentId, currentPage, path).then((result)=>{
            if (current) {
                const fetchedPage = getContentByRef(result.root.$ref, result);
                if (fetchedPage.models) {
                    const { pageable , highlightedArticle  } = fetchedPage.models;
                    const { paged  } = parseBloomreachArticles(pageable, highlightedArticle, result);
                    setResult((state)=>swcHelpers.objectSpread({}, state, {
                            paged: swcHelpers.objectSpread({}, paged, {
                                items: [
                                    ...state.paged.items,
                                    ...paged.items
                                ]
                            })
                        })
                    );
                }
                setLoading(false);
            }
        }).catch((err)=>{
            if (current) {
                console.error(err);
                setError(err);
                setLoading(false);
            }
        });
        return ()=>{
            current = false;
        };
    }, [
        url,
        currentPage,
        result1.paged.currentPage,
        page,
        componentId,
        isMultilingualEnabled,
        localeTransformed, 
    ]);
    return {
        loading,
        error,
        result: result1,
        loadNextPage
    };
};

export { useBloomreachArticles };
//# sourceMappingURL=use-bloomreach-articles.js.map
